/** Strings owned by `src/features/reports/` — PLAN-FASE3.md WP-04's
 * `/reports` library: 5 report cards (vitaliteitstrends, deelnamerapport,
 * challenge-resultaten, communicatiebereik, documentgebruik), each with a
 * CSV export. No AI-maandsamenvatting — explicitly out of scope. */
export const reports = {
  page: {
    title: 'Reports',
    lead: 'Reports for {{company}}, built from existing data — no separate report data is stored.',
    noScope: 'Select a company to see its reports.',
    forbidden: 'You are not allowed to see this company’s reports.',
  },
  library: {
    title: 'Report library',
  },
  cards: {
    vitaliteitstrends: {
      title: 'Monthly vitality trends',
      description: 'Total steps per month across the company.',
    },
    deelnamerapport: {
      title: 'Participation report',
      description: 'How many members are active, and how recently.',
    },
    'challenge-resultaten': {
      title: 'Challenge results',
      description: 'Challenges by status and average participant progress.',
    },
    communicatiebereik: {
      title: 'Communication reach',
      description: 'Sent, delivered and opened notifications.',
    },
    documentgebruik: {
      title: 'Document usage',
      description: 'Published/archived documents and their total views.',
    },
  },
  actions: {
    exportCsv: 'Export CSV',
    exportPdf: 'Export PDF',
  },
  export: {
    pdfFallbackNote: 'PDF export is not available yet — a CSV file was downloaded instead.',
    error: 'Could not export this report.',
  },
} as const;
